
import { Class } from './class.js';

export const Context = Class.extend('context').include({

    initialize(){
        this.assignProps({ root: this });
    },

    async run(fn){
        let out;
        try {
            out = await fn(this);
        } catch (e){
            await this.destroy();
            throw e;
        }
        await this.destroy();
        return out;
    },

    fork(){
        const out = this.constructor.new();
        out.assignProps({ parent: this, root: this?.root });
        if(this._serviceInterceptors){
            out._serviceInterceptors = { ...this._serviceInterceptors };
        }
        return out;
    },

    getOrCreate(name, fn){
        if(this[name]) return this[name];
        if(!fn) return;
        this[name] = fn();
        return this[name];
    },

    async destroy(){
        const resources = Object.values(this);
        while(resources.length){
            const resource = await resources.shift();
            if(typeof resource == 'object' && !(resource instanceof Context) && typeof resource.destroy == 'function'){
                await resource.destroy();
            }
        }
    }
});
